import { render, staticRenderFns } from "./FieldTextareaComponent.vue?vue&type=template&id=60dec703&scoped=true"
import script from "./FieldTextareaComponent.vue?vue&type=script&lang=js"
export * from "./FieldTextareaComponent.vue?vue&type=script&lang=js"
import style0 from "./FieldTextareaComponent.vue?vue&type=style&index=0&id=60dec703&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dec703",
  null
  
)

export default component.exports